import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  display: flex;
  width: 16.678125rem;
  top: 4.75rem;
  left: 0.70625rem;
  z-index: 50;
  background: #ffffff;
  flex-direction: column;
  user-select: none;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;

  border-radius: 0.17625rem;
`;

export const Sections = styled.div`
  width: 15rem;
  display: flex;
  justify-content: space-between;
  font-size: 0.646875rem;
  margin-left: 0.8rem;
  margin-top: 1.294375rem;
  margin-bottom: 0.8rem;
`;
export const Option = styled.span`
  cursor: pointer;
  font-weight: 600;
  color: ${({ active }) => (active ? "#232323" : "#A9AEB4")};
  transition: color 0.5s ease;
`;
